import { Observable } from './observable.js';

/**
 * Options for creating an IntervalObservable.
 */
export interface IntervalObservableInit {
    /** The interval time in milliseconds */
    interval: number;
    /** Optional flag to emit the first value immediately */
    immediate?: boolean;
}

/**
 * Creates an Observable that emits at a specified interval.
 *
 * @param options Options for creating the IntervalObservable.
 *
 * @returns An Observable that emits a number at the specified interval.
 */
export const createIntervalObservable = ({ interval, immediate = false }: IntervalObservableInit) => new Observable<number>(subscriber => {
    // an emit counter
    let run = 0;
    // create an interval and emit the run count to the subscriber
    const id = window.setInterval(() => subscriber.next(++run), interval);
    // if immediate is true, emit the first value immediately
    if (immediate) subscriber.next(++run);
    // add teardown logic to clear the interval when the subscription is disposed
    subscriber.addTeardown(() => window.clearInterval(id));
});
